import Helpers from './Helpers'

// Keeps track of the number of rooms left to configure.
class RoomConfigTotals {
    constructor(el) {
        this.el = el

        return this
    }

    activate() {
        if (this.el === null) {
            return
        }

        this.listeners()

        this.update()

        return this
    }

    listeners() {
        if (this.el === null) {
            return
        }

        new Helpers(this.el.querySelectorAll('[type="checkbox"]')).eventListener((e) => {
            this.update()
        }, 'change')

        return this
    }

    update() {
        if (this.el === null) {
            return
        }

        const requiredElement = document.getElementById('RoomConfigCountRequired')

        if (requiredElement === null) {
            return
        }

        const required = parseInt(requiredElement.innerText, 10)

        const count = this.el.querySelectorAll('[type="checkbox"]:checked').length

        const remaining = required - count

        new Helpers(document.getElementById('RoomConfigFeedback')).removeClass('complete')

        new Helpers(this.el.querySelectorAll('[type="checkbox"]')).removeAttributes(['disabled'])

        document.getElementById('RoomConfigFeedback').innerHTML = `<h3>Choose <b>${remaining}</b> more bedroom(s).</h3>`

        if (remaining === 0) {
            new Helpers(document.getElementById('RoomConfigFeedback')).addClass('complete')

            document.getElementById('RoomConfigFeedback').innerHTML = '<h3>Correct number of bedrooms chosen.</h3>'

            new Helpers(this.el.querySelectorAll('[type="checkbox"]:not(:checked)')).setAttributes({ disabled: true })
        }

        return this
    }
}

// Disable zip and link radios if the bedroom is not selected.
class RoomConfigRow {
    constructor(el) {
        this.el = el

        if (this.el === null) {
            return
        }

        this.input = el.querySelector('[type="checkbox"]')

        if (this.input !== null) {
            this.radios = el.querySelectorAll('[type="radio"]')
            this.ul = el.querySelectorAll('ul')
            this.p = el.querySelectorAll('p')

            if (this.input.checked) {
                new Helpers(this.radios).removeAttributes(['disabled'])
                new Helpers(this.ul).removeClass('hidden')
                new Helpers(this.p).removeClass('hidden')
            } else {
                new Helpers(this.radios).setAttributes({ disabled: true })
                new Helpers(this.ul).addClass('hidden')
                new Helpers(this.p).addClass('hidden')
            }
        }

        return this
    }

    activate() {
        if (this.el === null) {
            return
        }

        this.listeners()

        return this
    }

    listeners() {
        if (this.el === null) {
            return
        }

        new Helpers(this.input).eventListener((e) => {
            if (e.currentTarget.checked) {
                new Helpers(this.radios).removeAttributes(['disabled'])
                new Helpers(this.ul).removeClass('hidden')
                new Helpers(this.p).removeClass('hidden')
            } else {
                new Helpers(this.radios).setAttributes({ disabled: true })
                new Helpers(this.ul).addClass('hidden')
                new Helpers(this.p).addClass('hidden')
            }
        })
        return this
    }
}

try {
    // Instantiate the objects above.
    Array.from(document.getElementsByClassName('bedroom-config-row')).forEach((el) => {
        new RoomConfigRow(el).activate()
    })
    // FIXME(jameskennedy@classic.co.uk): Use class name not id.
    const totals = document.getElementById('MainContent_pnlBedConfiguration')
    if (totals !== null) {
        new RoomConfigTotals(totals).activate()
    }
} catch (e) {
    console.log(e)
}